import React, { Fragment } from 'react';
//import PropTypes from 'prop-types';
import { Dialog } from './../../common/dialog';

const ShippingModal = React.memo((props) => {
    const hideHandler = () => {
        props.setIdModal(null);
        props.hideShippingModal();
    };

    const saveHandler = () => {
        props.saveShipping();
    };

    let selectedOrder = null;
    for (let i = 0; i < props.orders.length; i++) {
        if (parseInt(props.orders[i].id) === parseInt(props.idModal)) {
            selectedOrder = props.orders[i];
            break;
        }
    }

    let saveButtonLabel = <Fragment>Save <i className="fas fa-save" /></Fragment>;
    if (props.isSavingShipping) {
        saveButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }
    
    let actions = [
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Cancel</button>,
        <button key="shipping-button" className="btn btn-light btn-sm action-button" onClick={saveHandler} disabled={props.isSavingShipping}>{saveButtonLabel}</button>,
    ];
    return (
        <Dialog
            name="shipping-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 800 }}
            bodyStyle={{ overflow: 'initial' }}
            className="shipping-dialog"
        >
            <div className="shipping-modal-container">
                <h1>Shipping Information</h1>
                <div className="field">
                    <div><b>Quantity</b></div>
                    <input type="text" value={props.shippingQuantity} onChange={(event) => props.setShippingQuantity(event.target.value)} />
                </div>
                <div className="field">
                    <div><b>Weight</b></div>
                    <input type="text" value={props.shippingWeight} onChange={(event) => props.setShippingWeight(event.target.value)} />
                </div>
                <div className="field">
                    <div><b>Number of packages</b></div>
                    <input type="text" value={props.shippingNumPackages} onChange={(event) => props.setShippingNumPackages(event.target.value)} />
                </div>
                <div className="field">
                    <div><b>Tracking Number</b></div>
                    <input type="text" value={props.trackingNumber} onChange={(event) => props.setTrackingNumber(event.target.value)} />
                </div>
                <div className="field">
                    <div><b>Shipping Method</b></div>
                    <select value={props.shippingMethod} onChange={(event) => props.setShippingMethod(event.target.value)}>
                        <option value="">Select option</option>
                        <option value="FedEx">FedEx</option>
                        <option value="UPS">UPS</option>
                        <option value="USPS Click & Ship">USPS Click & Ship</option>
                        <option value="Local delivery">Local delivery</option>
                        <option value="Client pickup">Client pickup</option>
                    </select>
                </div>
                <div><b>Ship Email:</b> {selectedOrder != null ? selectedOrder.shipEmail : ''}</div>
            </div>
        </Dialog >
    );
});

export default ShippingModal;
